import api from './api';
import { Provider } from '../types/api.types';

export interface FeaturedProvider extends Provider {
  featuredSettings?: {
    isFeatured: boolean;
    featuredStartAt?: string;
    featuredEndAt?: string;
    featuredCategory?: string;
  };
}

export interface FeaturedProvidersResponse {
  success: boolean;
  data: FeaturedProvider[];
}

/**
 * Get featured providers for display
 * @param options - Optional filters (category, city, limit)
 */
export const getFeaturedProviders = async (options?: {
  category?: string;
  city?: string;
  limit?: number;
}): Promise<FeaturedProvidersResponse> => {
  const params = new URLSearchParams();
  
  if (options?.category) {
    params.append('category', options.category);
  }
  if (options?.city) {
    params.append('city', options.city);
  }
  if (options?.limit) {
    params.append('limit', options.limit.toString());
  }

  const response = await api.get<FeaturedProvidersResponse>(`/featured/providers?${params.toString()}`);
  return response.data;
};

/**
 * Track click on a featured provider
 * @param providerId - The provider ID
 */
export const trackFeaturedClick = async (providerId: string): Promise<void> => {
  try {
    await api.post(`/featured/track/click/${providerId}`);
  } catch (error) {
    // Silent fail for tracking
    console.error('Failed to track click:', error);
  }
};

/**
 * Track booking from a featured provider
 * @param providerId - The provider ID
 */
export const trackFeaturedBooking = async (providerId: string): Promise<void> => {
  try {
    await api.post(`/featured/track/booking/${providerId}`);
  } catch (error) {
    // Silent fail for tracking
    console.error('Failed to track booking:', error);
  }
};

const featuredService = {
  getFeaturedProviders,
  trackFeaturedClick,
  trackFeaturedBooking,
};

export default featuredService;
